export default "__VITE_ASSET__Dp9rX1tz__"